import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const MediaBaseStyles = css<{ theme: StyledTheme }>`
  > img {
    margin: 0 auto;
  }
`;
